import { useEffect, useState } from "react";
import { api } from "@/api/client";
import { Sparkles } from "lucide-react";

/**
 * 첫 화면 추천 질문 칩 — 신규 사용자 온보딩용.
 * 서버 게이트(SUGGESTED_QUESTIONS_ENABLED, 기본 off)가 꺼져 있으면 빈 목록이
 * 내려와 아무것도 렌더링하지 않는다(기존 화면과 100% 동일 — 회귀 0).
 * 칩을 누르면 그 질문을 즉시 전송한다.
 */
export default function SuggestedQuestions({
  onPick,
  disabled,
}: {
  onPick: (q: string) => void;
  disabled?: boolean;
}) {
  const [items, setItems] = useState<string[]>([]);

  useEffect(() => {
    api.suggestions().then((r) => setItems(r.items.slice(0, 6))).catch(() => {});
  }, []);

  if (items.length === 0) return null;

  return (
    <div className="mx-auto w-full max-w-2xl text-left">
      <h3 className="mb-2 flex items-center gap-1.5 text-sm font-semibold">
        <Sparkles className="h-4 w-4 text-[#EB4E26]" /> 이렇게 물어보세요
      </h3>
      <div className="flex flex-wrap gap-2">
        {items.map((q) => (
          <button
            key={q}
            onClick={() => onPick(q)}
            disabled={disabled}
            className="rounded-full border border-border bg-card px-3 py-1.5 text-sm text-foreground hover:bg-muted active:bg-muted disabled:opacity-40"
          >
            {q}
          </button>
        ))}
      </div>
    </div>
  );
}
